export const SECTIONS = [
  {
    title: 'Company',
    className: 'col-sm-6 col-md-3 col-lg-2',
    links: [
      {
        label: 'About Us',
        url: '/about-us',
        id: 'about-us',
      },
      {
        label: 'Careers',
        url: '/careers',
        id: 'careers',
      },
      {
        label: 'Press',
        url: '/in-the-press',
        id: 'in-the-press',
      },
      {
        label: 'Testimonials',
        url: '/testimonials',
        id: 'testimonials',
      },
    ],
  },
  {
    title: 'Products',
    className: 'col-sm-6 col-md-3 col-lg-2',
    links: [
      {
        label: 'Blink Health',
        url: '/',
        id: 'homepage',
      },
      {
        label: 'BlinkRx',
        url: '/blinkrx',
        id: 'blinkrx',
      },
      {
        label: 'Quick Save',
        url: '/quicksave',
        id: 'quicksave',
      },
    ],
  },
  {
    title: 'Services',
    className: 'col-sm-6 col-md-3 col-lg-2',
    links: [
      {
        label: 'Home Delivery',
        url: '/home-delivery',
        id: 'home-delivery',
      },
      {
        label: 'Online Prescriptions',
        url: '/online-rx',
        id: 'online-prescriptions',
      },
      {
        label: 'Pharmacy Finder',
        url: '/participating-pharmacies',
        id: 'pharmacy-finder',
      },
      {
        label: 'Price Match Guarantee',
        url: '/price-match-guarantee',
        id: 'price-match-guarantee',
      },
    ],
  },
  {
    title: 'Resources',
    className: 'col-sm-6 col-md-3 col-lg-2',
    links: [
      {
        label: 'Blog',
        url: '/blog',
        id: 'blog',
      },
      {
        label: 'For Doctors',
        url: '/doctors',
        id: 'doctors',
      },
      {
        label: 'For Pharmacists',
        url: '/pharmacists',
        id: 'pharmacists',
      },
      {
        label: 'Medication Directory',
        url: '/medications',
        id: 'medication-directory',
      },
    ],
  },
  {
    title: 'Common Drugs',
    className: 'col-sm-12 col-md-6 col-lg-4',
    linksContainerStyle: {
      columnCount: 2,
    },
    links: [
      {
        label: 'Atorvastatin',
        url: '/atorvastatin',
        id: 'atorvastatin',
      },
      {
        label: 'Buprenorphine',
        url: '/buprenorphine',
        id: 'buprenorphine',
      },
      {
        label: 'Duloxetine',
        url: '/duloxetine',
        id: 'duloxetine',
      },
      {
        label: 'Finasteride',
        url: '/finasteride',
        id: 'finasteride',
      },
      {
        label: 'Montelukast',
        url: '/montelukast',
        id: 'montelukast',
      },
      {
        label: 'Sildenafil',
        url: '/sildenafil',
        id: 'sildenafil',
      },
      {
        label: 'Tadalafil',
        url: '/tadalafil',
        id: 'tadalafil',
      },
      {
        label: 'Valacyclovir',
        url: '/valacyclovir',
        id: 'valacyclovir',
      },
    ],
  },
];
